import Avatar from '@sdk/components/avatar/Avatar';
import StatusLabel, { StatusLabelType } from '@sdk/components/ui/StatusLabel';
import { pgettext } from '@sdk/lang/gettext';

import GroupsBlue from '@web/assets/svg/Icons/32/groups-blue.svg';
import { useConversationState } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { ConversationSearchBar } from '@web/conversations/Conversation/ConversationSearchBar/ConversationSearchBar';
import { ConversationHeaderActions } from '@web/conversations/Conversation/ConversationHeaderActions/ConversationHeaderActions';
import { useConversationLayoutContext } from '@web/conversations/Conversation/ConversationLayout/ConversationLayoutProvider';
import { useConversationMembers } from '@web/conversations/Conversation/ConversationMembers/conversationMembers.hooks';
import { getBillingDate } from '@web/account/utils';

import {
  HeaderActionsWrapper,
  IconWrapper,
  MembersButton,
  Name,
  PeopleIcon,
  TitleWrapper,
  Wrapper,
  BadgesWrapper,
  ArchivedBadgeWrapper,
} from './conversationHeader.styles';
import { MutedConversationBadge } from './MutedConversationBadge';

export const ConversationHeader = () => {
  const { isArchived, isSilenced, interlocutor, name } = useConversationState();
  const { membersCount } = useConversationMembers();
  const { isSidebarCollapsed, toggleSidebar } = useConversationLayoutContext();
  const hasBadge = isSilenced || isArchived;

  return (
    <Wrapper>
      <IconWrapper>{interlocutor ? <Avatar user={interlocutor} /> : <GroupsBlue />}</IconWrapper>

      <TitleWrapper>
        <Name>{name}</Name>
        {hasBadge && (
          <BadgesWrapper>
            {isSilenced && <MutedConversationBadge />}
            {isArchived && (
              <ArchivedBadgeWrapper>
                <StatusLabel
                  label={pgettext('conversation badge', 'archived')}
                  type={StatusLabelType.info}
                />
              </ArchivedBadgeWrapper>
            )}
          </BadgesWrapper>
        )}
      </TitleWrapper>

      <HeaderActionsWrapper>
        <ConversationSearchBar />

        <MembersButton
          aria-label="toggle sidebar"
          isActive={!isSidebarCollapsed}
          onClick={() => toggleSidebar()}>
          <PeopleIcon aria-hidden="true" isActive={!isSidebarCollapsed} />
          {membersCount}
        </MembersButton>

        <ConversationHeaderActions />
      </HeaderActionsWrapper>
    </Wrapper>
  );
};
